import { ref, onBeforeUnmount } from 'vue';
import { ParentBridge } from '@monorepo/aichat-framebridge';

const getOrigin = (url: string) => {
  const urlObj = new URL(url);
  return urlObj.origin;
};

export function useFrameBridge(url: string) {
  const childOrigin = getOrigin(url);
  const iframeRef = ref<HTMLIFrameElement | null>(null);
  let bridge: ParentBridge | null = null;

  function init(iframeEl: HTMLIFrameElement) {
    iframeRef.value = iframeEl;
    const win = iframeEl.contentWindow;
    if (win) bridge = new ParentBridge(win, childOrigin);
    else {
      iframeEl.addEventListener(
        'load',
        () => {
          bridge = new ParentBridge(iframeEl.contentWindow!, childOrigin);
        },
        { once: true }
      );
    }
    return bridge;
  }

  function emit(eventName: string, payload?: any) {
    bridge?.emitToChild(eventName, payload);
  }
  function call(method: string, params?: any) {
    return bridge?.callChild(method, params) as Promise<any>;
  }

  onBeforeUnmount(() => bridge?.destroy());

  return { iframeRef, init, emit, call, bridge };
}
